export const TVA = 0.2
export const STRIPE_PERCENTAGE = 0.03
export const STYLEEP_PERCENTAGE = 0.03
export const GLOBAL_STYLEEP_PERCENTILE = STRIPE_PERCENTAGE + STYLEEP_PERCENTAGE